import { map, trim, endsWith } from 'lodash-es'

/** 组合网址 */
export function join (...args) {
  map(args, (val, index) => {
    // 预防有双斜线的网址
    if (index === 0 && endsWith(val, '/')) {
      args[index] = val.slice(0, -1)
      return
    }

    args[index] = trim(val, '/')
  })

  return args.join('/')
}

/** 是否为 base64 */
export function isBase64 (...args) {
  let result = true
  map(args, val => {
    if (result && val.indexOf(';base64,') === -1) {
      result = false
    }
  })

  return result
}

/** 官網子目錄之推廣域名前綴字串 ex: https://xxxxx.ooo/club/ 的 /club */
export function promoteUrl () {
  if (window.location.pathname.startsWith('/club/n/')) {
    return '/club'
  }
  return ''
}

/**
 * 跳轉登入或註冊(login || reg)
 */
export function toLogin(method = 'login') {
  window.location = promoteUrl() + '/member_vue.php?platform=1&method='+method+'&back=' + encodeURIComponent(document.URL)
}